// extracted by mini-css-extract-plugin
export default {"privacy":"Privacy_privacy__MN9bt","container":"Privacy_container__OvOZj","row":"Privacy_row__pPOHf","col":"Privacy_col__Ukf4C"};